import React, { isValidElement, useCallback } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import ObserverTextField from 'choerodon-ui/pro/lib/text-field/TextField';
import { getHeader } from '../../utils';
const ItemTitle = observer(function ItemTitle(props) {
    const { record, provided } = props;
    const editing = record.getState('editing');
    const handleEditBlur = useCallback(() => {
        record.setState('editing', false);
    }, []);
    const handleHeaderChange = useCallback((value) => {
        record.set('title', value);
    }, [record]);
    const title = record.get('title');
    const header = getHeader({ tab: record.get('tab'), title });
    return (React.createElement(React.Fragment, null, editing ? (React.createElement(ObserverTextField, { onBlur: handleEditBlur, value: isValidElement(header) ? title : header, onChange: handleHeaderChange, autoFocus: true })) : (React.createElement("span", Object.assign({}, provided.dragHandleProps, { style: { cursor: 'move' } }), toJS(header)))));
});
ItemTitle.displayName = 'ItemTitle';
export default ItemTitle;
